// extracted by mini-css-extract-plugin
export default {"playPauseBadgeHolder":"ogTyoRZ38WW5PzUG9gFW"};